<div class="d-flex flex-column">
  <form [formGroup]="form">
    <div class="form-group mb-4">
      <div class="row mb-2">
        <label for="subTypeSelect" class="col-6 d-flex align-items-center required">Sub type</label>
        <div class="col d-flex align-items-center">
          <mat-form-field>
            <mat-select
              id="subTypeSelect"
              (selectionChange)="subTypeSelectionChangeHandler($event)"
              [formControl]="formControls.subType"
              [disabled]="isSubTypeProtected"
            >
              <mat-option *ngFor="let subType of searchTagsTraySubTypes" [value]="subType.value">{{ subType.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <ng-container *ngIf="hasSubType">
      <div class="form-group mb-4 flex-vertical-gap-2">
        <osn-cxb-title-input-english-control [formControl]="formControls.titleEnglish"></osn-cxb-title-input-english-control>
        <osn-cxb-title-input-arabic-control [formControl]="formControls.titleArabic"></osn-cxb-title-input-arabic-control>
      </div>

      <osn-cxb-display-service-type-icon-control
        [formControl]="formControls.displayServiceTypeIcon"
      ></osn-cxb-display-service-type-icon-control>

      <div class="form-group mb-4">
        <div class="row">
          <label for="categoryListName" class="col-6 d-flex align-items-center required">Category List Name</label>
          <div class="col d-flex align-items-center">
            <mat-form-field>
              <input
                trim="blur"
                matInput
                [formControl]="formControls.categoryListName"
                type="text"
                id="categoryListName"
                autocomplete="off"
                data-testid="category-list-name-input-value"
              />
            </mat-form-field>
          </div>
        </div>
      </div>

      <h3 class="text-title-s-bold mb-3">Edit items</h3>
      <osn-cxb-reorderable-tray-form
        [formArray]="formControls.items"
        [template]="template"
        [nameSelector]="itemNameSelector"
        [formControlFactory]="formControlFactory"
        [minimumCount]="1"
        [maximumCount]="255"
        [isReadonly]="isReadonly || !accesses.screen.trayEditorScreen.trayFunctions"
      >
        <ng-template #template let-itemFormGroup let-selectedIndex="selectedIndex">
          <div class="inner-form" *ngIf="castItemFormGroup(itemFormGroup) as itemFormGroup">
            <div class="column-start-stretch" (click)="itemFormGroup.markAsTouched()">
              <h2 class="mb-5">Edit item {{ selectedIndex }}</h2>
              <div class="form-group mb-4">
                <div class="row" *ngIf="subType === SearchTagsTraySubType.OSNPlusContentGroup">
                  <label for="content_source" class="col-6 d-flex align-items-center required">Content source</label>
                  <div class="col-6">
                    <osn-cxb-content-group-selector
                      id="content_source"
                      [propagateOptionAsIs]="true"
                      [formControl]="itemFormGroup.controls.feed"
                      [isReadonly]="isReadonly || !accesses.screen.trayEditorScreen.trayFunctions"
                      [errorLabel]="
                        itemFormGroup.controls.feed.touched && itemFormGroup.controls.feed.hasError('required')
                          ? 'Required. Choose which content group the tray links to.'
                          : undefined
                      "
                    ></osn-cxb-content-group-selector>
                  </div>
                </div>
                <div class="row" *ngIf="subType === SearchTagsTraySubType.OndemandContentGroup">
                  <label for="independence_content_source" class="col-6 d-flex align-items-center required">Content source</label>
                  <div class="col-6">
                    <osn-cxb-tenant-independent-content-group-selector
                      id="independence_content_source"
                      [formControl]="itemFormGroup.controls.contentGroup"
                      [isReadonly]="isReadonly || !accesses.screen.trayEditorScreen.trayFunctions"
                      [errorLabel]="
                        itemFormGroup.controls.contentGroup.touched && itemFormGroup.controls.contentGroup.hasError('required')
                          ? 'Required. Choose which content group the tray links to.'
                          : undefined
                      "
                    ></osn-cxb-tenant-independent-content-group-selector>
                  </div>
                </div>
              </div>

              <div class="form-group mb-4">
                <osn-cxb-localized-text-form-control
                  [formControl]="itemFormGroup.controls.tagLocalized"
                  [maxLength]="18"
                  [multiline]="false"
                  label="Tag"
                  data-testid="tag-input"
                ></osn-cxb-localized-text-form-control>
              </div>
            </div>
          </div>
        </ng-template>
      </osn-cxb-reorderable-tray-form>

      <osn-cxb-targeting-control [hasCountryTargeting]="true" [hasUserTargeting]="true">
        <osn-cxb-user-targeting-control
          [userSegmentOptions]="userSegmentOptions"
          [userSegmentIdsControl]="formControls.userSegmentIds"
          [emitValueOnRegisterOnChange]="true"
        ></osn-cxb-user-targeting-control>
        <osn-cxb-country-targeting-control
          [countryOptions]="countryOptions"
          [countryIdsControl]="formControls.countryIds"
        ></osn-cxb-country-targeting-control>
      </osn-cxb-targeting-control>

      <h3 class="text-title-s-bold mb-3 mt-3">Scheduling</h3>
      <osn-cxb-scheduling-control [formControl]="formControls.scheduling"></osn-cxb-scheduling-control>
    </ng-container>
  </form>
</div>
